export const blockIconsActivitiesSchoolNew = (
	<span className='material-symbols-outlined'>school</span>
);
